export const CONFLUENCE_ACCESS_REQUEST_KEY = 'userConfluenceAccessStatus';
export const CONFLUENCE_ACCESS_REQUEST_TTL = 1800000; // 30 minutes
